module.exports = __webpack_public_path__ + "static/img/barra_5.51f50b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_5.png
// module id = fmBi
// module chunks = 1